var map = {
	"./frontend/AndroidGuide.vue": 7881,
	"./frontend/BetslipHistory.vue": 1224,
	"./frontend/BodyFB.vue": 403,
	"./frontend/ContactUs.vue": 5571,
	"./frontend/DataTable.vue": 6107,
	"./frontend/Deposit.vue": 808,
	"./frontend/FinishedMatches.vue": 299,
	"./frontend/History.vue": 9046,
	"./frontend/Home.vue": 9805,
	"./frontend/IOSGuide.vue": 7508,
	"./frontend/Iframe.vue": 2251,
	"./frontend/Index.vue": 8030,
	"./frontend/Live.vue": 5513,
	"./frontend/LiveScore.vue": 2184,
	"./frontend/MainMenu.vue": 7294,
	"./frontend/MaungFB.vue": 2614,
	"./frontend/Promotion.vue": 5042,
	"./frontend/Setting.vue": 758,
	"./frontend/TwodThreed.vue": 9105,
	"./frontend/VideoLink.vue": 3108,
	"./frontend/Withdraw.vue": 5098,
	"./frontend/auth/Login.vue": 9901,
	"./frontend/auth/Rule.vue": 7886,
	"./frontend/components/AccountSelect.vue": 3678,
	"./frontend/components/DataTable.vue": 3713,
	"./frontend/components/FBPreviewVoucher.vue": 3376,
	"./frontend/components/FBVoucher.vue": 7778,
	"./frontend/components/FootballTeamCard.vue": 8396,
	"./frontend/components/GroupBox.vue": 8747,
	"./frontend/components/InputSelectDrawModal.vue": 1307,
	"./frontend/components/LuckyWheel.vue": 187,
	"./frontend/components/NormalBox.vue": 9250,
	"./frontend/components/PreviewVoucher.vue": 3037,
	"./frontend/components/SideNav.vue": 850,
	"./frontend/components/Table.vue": 9763,
	"./frontend/components/ThreedGroupBox.vue": 5959,
	"./frontend/components/TwoDSelect.vue": 3841,
	"./frontend/components/Voucher.vue": 30,
	"./frontend/normal-user/2d/2d.vue": 83,
	"./frontend/normal-user/2d/ClosedDays.vue": 156,
	"./frontend/normal-user/2d/Home.vue": 799,
	"./frontend/normal-user/2d/Winner.vue": 7807,
	"./frontend/normal-user/3d/3d.vue": 7503,
	"./frontend/normal-user/3d/Home.vue": 6470,
	"./frontend/normal-user/DreamBooks.vue": 4010,
	"./frontend/normal-user/Index.vue": 6012,
	"./frontend/normal-user/bugyee/Room.vue": 7576,
	"./frontend/normal-user/game/Fishing.vue": 2437,
	"./frontend/normal-user/game/Game.vue": 1217,
	"./frontend/normal-user/game/Slot.vue": 1113,
	"./frontend/normal-user/shankomee/Room.vue": 703
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;